import React from 'react';
import { useSelector } from 'react-redux';

import {
  ANALYTICS_PAGE_NAMES,
  ANALYTICS_VIEW_FEATURE_LOCATIONS,
  ANALYTICS_VIEWS
} from 'dpl/constants/analytics';
import HorizontalSlider from 'dpl/components/HorizontalSlider';
import SectionViewTracker from 'dpl/common/components/SectionViewTracker';

import { usePuppyData } from '../hooks/usePuppyData';
import Section from './Section';
import SiblingPuppyCard from './SiblingPuppyCard';

export default function PuppySiblings() {
  const { puppyId } = useSelector(({ server }) => server);
  const { breeder, litter, puppy } = usePuppyData({
    puppyId
  });

  const { id: litterId, siblings } = litter;

  if (siblings.length === 0) {
    return null;
  }

  return (
    <SectionViewTracker
      name={ANALYTICS_PAGE_NAMES.PUPPY_PROFILE}
      category="puppy-profile-more-listings"
    >
      <section className="PuppySiblings container-xxl">
        <div className="font-16 pv12 pv20-md">
          <Section.Heading>{puppy.name}’s siblings</Section.Heading>
          <Section.Subheading className="mt2 mt4-md">
            {puppy.sibling_description}
          </Section.Subheading>
          <HorizontalSlider
            className="PuppySiblingsSlider mt8 mt12-md"
            containerClassName="PuppySiblingsSlider__container flex flex-nowrap w-100"
            iconClassName="f3 bg-white o-80 br-100 box-shadow-strong b black pv2 ph2"
          >
            {siblings.map((sibling, idx) => (
              <div key={idx} className="flex ws-normal">
                <SiblingPuppyCard
                  analytics={{
                    breeder_profile_id: breeder.id,
                    litter_id: litterId,
                    position: idx + 1,
                    view: ANALYTICS_VIEWS.PUPPY_PROFILE,
                    view_feature_location:
                      ANALYTICS_VIEW_FEATURE_LOCATIONS.SIBLINGS_CAROUSEL
                  }}
                  puppy={sibling}
                />
              </div>
            ))}
          </HorizontalSlider>
        </div>
      </section>
    </SectionViewTracker>
  );
}
